import CommonEdit from "@/components/common/Edit"
import ClientForm from "../forms/ClientForm"
import { FC, useEffect, useState } from "react"
import { clientForm } from "@/utils/objects"
import { singleProp } from "@/interface/dataInterface"
import axiosInstance from "@/utils/axiosInstance"

const ClientEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState(clientForm)

    useEffect(() => {
        const unsub = async () => {
            const response = await axiosInstance.get(`/auto-service/clients/${prop}`)
            setFormProp(response.data)
        }

        unsub()
    }, [prop])

    return (
        <CommonEdit id={prop} resource="auto-service/clients" data={formProp} title="Edit">
            <ClientForm mode="edit" formProp={formProp} setFormProp={setFormProp} />
        </CommonEdit>
    )
}

export default ClientEdit